import type { SVGProps } from "react";
// generated from Percent.svg — do not edit manually
// prettier-ignore
export default function Percent(props: SVGProps<SVGSVGElement>) {
  return (<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" {...props}><path d="M 4 20 L 20 4 M 10 7 C 10 8.657 8.6569 10 7 10 C 5.3431 10 4 8.657 4 7 C 4 5.343 5.3431 4 7 4 C 8.6569 4 10 5.343 10 7 Z M 20 17 C 20 18.657 18.6569 20 17 20 C 15.3431 20 14 18.657 14 17 C 14 15.343 15.3431 14 17 14 C 18.6569 14 20 15.343 20 17 Z" stroke="currentColor" strokeWidth="1.5"/></svg>);
}
